import Cookies from 'js-cookie'

// Launch Darkly Context
// https://docs.launchdarkly.com/home/contexts/
export interface LDContext {
  kind: 'guest' | 'user'
  key?: string
}

export interface LDMultiContext {
  kind: 'multi'
  user: {
    key?: string
  }
  guest: {
    key?: string
  }
}

// Anonymous user context
// Used for `Logged out Experimentation`
export const guestContext = (): LDContext => ({
  kind: 'guest',
  key: Cookies.get('bl_anon_id') || '',
})

// Known user context
// Used for `Logged in Experimentation`
export const userContext = (): LDContext => ({
  kind: 'user',
  key: window.currentUser?.id?.toString(),
})

// Should only be used to merge contexts on signup
// Used for `Signup Experimentation`
export const multiContext = (): LDMultiContext => ({
  kind: 'multi',
  user: {
    key: userContext().key,
  },
  guest: {
    key: guestContext().key,
  },
})
